/**
 * Public icon barrel.
 *
 * 1. Re-exports every SVGR-generated icon from `./local-icons` (which
 *    `pnpm build-icons` regenerates on every run — do not hand-edit
 *    `./local-icons/index.ts`).
 * 2. Below that, re-exports a handful of icons under the same name but
 *    wrapped with `withDefaultColor`. Explicit named exports take
 *    precedence over the `export *` above, so consumers calling
 *    `<Lightning />` get the wrapped version (which renders in
 *    `#DE6F18` by default but accepts any parent `color` override).
 *
 * Adding a new default-colored icon: drop the SVG, run `pnpm build-icons`,
 * then add an entry in the override block below. The build pipeline never
 * touches this file.
 */
import { withDefaultColor } from '../../withDefaultColor';
import {
  Calculator as CalculatorRaw,
  Contract as ContractRaw,
  GitBranch as GitBranchRaw,
  Grid as GridRaw,
  InsightsAnalyticsSquare as InsightsAnalyticsSquareRaw,
  Lightning as LightningRaw,
  McpConnector as McpConnectorRaw,
} from './local-icons';

export * from './local-icons';

// --- Default-color overrides (see file header) ---

/** Calculator icon. Default glyph color: Success-600 (`#42AE5C`). */
export const Calculator = withDefaultColor(CalculatorRaw, '#42AE5C');

/** Document / contract icon. Default glyph color: VayuBlue-600 (`#0521FF`). */
export const Contract = withDefaultColor(ContractRaw, '#0521FF');

/** Git branch icon. Default glyph color: Content/Primary (`#020F20`). */
export const GitBranch = withDefaultColor(GitBranchRaw, '#020F20');

/** Grid / table layout icon. Default glyph color: Content/Primary (`#020F20`). */
export const Grid = withDefaultColor(GridRaw, '#020F20');

/** Insights / trending-up-in-square icon. Default glyph color: Purple-600 (`#6F28FF`). */
export const InsightsAnalyticsSquare = withDefaultColor(
  InsightsAnalyticsSquareRaw,
  '#6F28FF',
);

/** Lightning bolt icon. Default glyph color: Orange-600 (`#DE6F18`). */
export const Lightning = withDefaultColor(LightningRaw, '#DE6F18');

/** MCP / Claude-connect logo. Default glyph color: Claude brand orange (`#D97757`). */
export const McpConnector = withDefaultColor(McpConnectorRaw, '#D97757');
